// import React, { useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import logo from "../assets/coreopsai.png";
// import { backend_url } from "../config";

// function ForgotPassword() {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError("");
//     setMessage("");
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${backend_url}/request-password-reset`,
//         {
//           email,
//         }
//       );
//       setMessage(response.data.message);
//       setLoading(false);
//     } catch (err) {
//       if (err.response && err.response.data) {
//         setError(err.response.data.message);
//       } else {
//         setError("An unexpected error occurred. Please try again.");
//       }
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         height: "100vh",
//         width: "100%",
//         backgroundColor: "#f9f9f9",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "400px",
//           padding: "2rem",
//           borderRadius: "12px",
//           boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
//           backgroundColor: "white",
//           textAlign: "center",
//           animation: "fadeIn 0.5s ease",
//         }}
//       >
//         <img
//           src={logo}
//           alt="CoreOpsAI"
//           style={{
//             width: "150px",
//             marginBottom: "1.5rem",
//           }}
//         />

//         <h2
//           style={{
//             color: "#333",
//             fontSize: "1.8rem",
//             marginBottom: "1.5rem",
//             position: "relative",
//             display: "inline-block",
//           }}
//         >
//           Forgot Password
//           <span
//             style={{
//               content: "",
//               position: "absolute",
//               bottom: "-8px",
//               left: "0",
//               width: "100%",
//               height: "3px",
//               background: "linear-gradient(90deg, #673ab7, #9c27b0)",
//               borderRadius: "1.5px",
//             }}
//           ></span>
//         </h2>

//         <p
//           style={{
//             color: "#666",
//             marginBottom: "1.5rem",
//             fontSize: "0.95rem",
//           }}
//         >
//           Enter your email address and we'll send you a link to reset your
//           password.
//         </p>

//         {error && (
//           <div
//             style={{
//               padding: "0.8rem",
//               marginBottom: "1.5rem",
//               borderRadius: "8px",
//               backgroundColor: "#ffebee",
//               color: "#d32f2f",
//               fontSize: "0.9rem",
//               borderLeft: "4px solid #d32f2f",
//             }}
//           >
//             {error}
//           </div>
//         )}

//         {message && (
//           <div
//             style={{
//               padding: "0.8rem",
//               marginBottom: "1.5rem",
//               borderRadius: "8px",
//               backgroundColor: "#e8f5e9",
//               color: "#2e7d32",
//               fontSize: "0.9rem",
//               borderLeft: "4px solid #2e7d32",
//             }}
//           >
//             {message}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
//           <div style={{ marginBottom: "1.5rem" }}>
//             <label
//               htmlFor="email"
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: "#555",
//                 fontSize: "0.9rem",
//               }}
//             >
//               Email Address
//             </label>
//             <input
//               type="email"
//               id="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               style={{
//                 width: "100%",
//                 padding: "0.8rem",
//                 border: "1px solid #e0e0e0",
//                 borderRadius: "8px",
//                 fontSize: "1rem",
//                 transition: "all 0.3s ease",
//               }}
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             style={{
//               width: "100%",
//               padding: "0.8rem",
//               background: "linear-gradient(90deg, #673ab7, #9c27b0)",
//               color: "white",
//               border: "none",
//               borderRadius: "8px",
//               fontSize: "1rem",
//               fontWeight: "600",
//               cursor: loading ? "not-allowed" : "pointer",
//               transition: "all 0.3s ease",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               gap: "10px",
//               opacity: loading ? 0.8 : 1,
//             }}
//           >
//             {loading ? "Sending..." : "Send Reset Link"}
//           </button>

//           <div
//             style={{
//               marginTop: "1.5rem",
//               textAlign: "center",
//               paddingTop: "1.5rem",
//               borderTop: "1px solid #e0e0e0",
//             }}
//           >
//             <Link
//               to="/signin"
//               style={{
//                 color: "#673ab7",
//                 textDecoration: "none",
//                 fontWeight: "500",
//                 transition: "color 0.3s ease",
//               }}
//             >
//               Back to Sign In
//             </Link>
//           </div>
//         </form>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default ForgotPassword;




import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/coreopsai.png";
import { backend_url } from "../config";

/* ------------------------------------------------------------------ */
/* Inline SVG icons                                                   */
/* ------------------------------------------------------------------ */
const Icon = {
  mail: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  ),
  alert: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 9v4M12 17h.01" />
      <path d="M10.3 3.9 1.8 18.1A2 2 0 0 0 3.5 21h17a2 2 0 0 0 1.7-2.9L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  arrowLeft: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
};

/* ------------------------------------------------------------------ */
/* Candidate stack data (left-panel visual)                           */
/* ------------------------------------------------------------------ */
const CANDIDATES = [
  { initials: 'PS', name: 'Priya Sharma', role: 'Senior Backend Engineer', score: 94, tags: ['Java', 'Spring Boot', '6 yrs'] },
  { initials: 'RK', name: 'Rahul Kapoor', role: 'Full-Stack Developer', score: 87, tags: ['React', 'Node.js', '4 yrs'] },
  { initials: 'AN', name: 'Ananya Nair', role: 'Data Engineer', score: 81, tags: ['Python', 'SQL', '5 yrs'] },
];

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${backend_url}/request-password-reset`,
        { email }
      );
      setMessage(response.data.message || "Reset link sent successfully!");
      setLoading(false);
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message);
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      setLoading(false);
    }
  };

  return (
    <div className="ch-root">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');

        /* ROOT VARIABLES */
        .ch-root {
          --ink: #0b1220;
          --ink-2: #131f36;
          --line: rgba(255, 255, 255, 0.08);
          --paper: #f6f7f9;
          --card: #ffffff;
          --text: #172033;
          --muted: #64748b;
          --accent: #4c5fff;
          --accent-soft: rgba(76, 95, 255, 0.1);
          --match: #21c07a;
          --danger: #d84545;
          --success-bg: #f0fdf4;
          --success-border: #bbf7d0;
          --success-text: #15803d;
          --radius: 14px;

          min-height: 100vh;
          display: grid;
          grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
          font-family: 'Inter', system-ui, sans-serif;
          background: var(--paper);
          color: var(--text);
          margin: 0;
        }

        /* ============ LEFT: product panel ============ */
        .ch-panel {
          position: relative;
          background:
            radial-gradient(900px 500px at 85% -10%, rgba(76, 95, 255, 0.22), transparent 60%),
            radial-gradient(700px 600px at -10% 110%, rgba(33, 192, 122, 0.10), transparent 55%),
            var(--ink);
          color: #eef1f7;
          padding: 48px 56px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        .ch-panel::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: linear-gradient(var(--line) 1px, transparent 1px),
            linear-gradient(90deg, var(--line) 1px, transparent 1px);
          background-size: 56px 56px;
          mask-image: radial-gradient(700px 700px at 30% 30%, #000 0%, transparent 75%);
          pointer-events: none;
        }
        .ch-panel > * { position: relative; z-index: 1; }

        .ch-wordmark {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          font-size: 20px;
          letter-spacing: 0.02em;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .ch-wordmark .dot { color: var(--match); }

        .ch-headline {
          margin: 56px 0 0;
          font-family: 'Space Grotesk', sans-serif;
          font-size: clamp(30px, 3.2vw, 44px);
          line-height: 1.12;
          font-weight: 600;
          letter-spacing: -0.02em;
          max-width: 15ch;
        }
        .ch-headline em {
          font-style: normal;
          color: var(--match);
        }
        .ch-sub {
          margin: 18px 0 0;
          font-size: 15.5px;
          line-height: 1.6;
          color: #a6b0c3;
          max-width: 42ch;
        }

        .ch-stack {
          margin-top: 44px;
          display: grid;
          gap: 12px;
          max-width: 460px;
        }
        .ch-card {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.09);
          border-radius: 12px;
          padding: 14px 16px;
          display: grid;
          grid-template-columns: 40px 1fr auto;
          gap: 14px;
          align-items: center;
          backdrop-filter: blur(6px);
          animation: ch-rise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;
        }
        .ch-card:nth-child(1) { animation-delay: 0.15s; }
        .ch-card:nth-child(2) { animation-delay: 0.3s; transform-origin: left; scale: 0.985; opacity: 0.92; }
        .ch-card:nth-child(3) { animation-delay: 0.45s; scale: 0.97; opacity: 0.82; }

        .ch-avatar {
          width: 40px; height: 40px;
          border-radius: 10px;
          display: grid; place-items: center;
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 600; font-size: 13px;
          background: var(--accent-soft);
          color: #9fb0ff;
          border: 1px solid rgba(76, 95, 255, 0.35);
        }
        .ch-card-name { font-weight: 600; font-size: 14px; }
        .ch-card-role { font-size: 12.5px; color: #8e99ad; margin-top: 2px; }
        .ch-tags { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
        .ch-tag {
          font-size: 10.5px;
          padding: 2px 8px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #aeb8ca;
        }

        .ch-score { text-align: right; }
        .ch-score-num {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          font-size: 18px;
          color: var(--match);
        }
        .ch-score-label {
          font-size: 10px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #7d8798;
        }
        .ch-meter {
          margin-top: 6px;
          width: 84px; height: 4px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.1);
          overflow: hidden;
        }
        .ch-meter i {
          display: block; height: 100%;
          border-radius: inherit;
          background: linear-gradient(90deg, var(--accent), var(--match));
          transform-origin: left;
          animation: ch-fill 1.1s 0.5s cubic-bezier(0.2, 0.7, 0.2, 1) both;
        }

        .ch-panel-foot {
          margin-top: auto;
          padding-top: 40px;
          display: flex;
          gap: 28px;
          font-size: 13px;
          color: #8e99ad;
        }
        .ch-panel-foot strong {
          display: block;
          font-family: 'Space Grotesk', sans-serif;
          font-size: 17px;
          color: #eef1f7;
          font-weight: 600;
          margin-bottom: 2px;
        }

        @keyframes ch-rise {
          from { opacity: 0; translate: 0 16px; }
          to { opacity: inherit; translate: 0 0; }
        }
        @keyframes ch-fill {
          from { transform: scaleX(0); }
          to { transform: scaleX(var(--fill, 1)); }
        }

        /* ============ RIGHT: Centered auth side ============ */
        .ch-auth {
          height: 100vh; 
          position: sticky; 
          top: 0;
          display: flex;
          align-items: center; 
          justify-content: center;
          padding: 24px;
          box-sizing: border-box;
        }
        
        .ch-auth-card {
          width: min(400px, 100%);
          box-sizing: border-box;
        }
        .ch-logo { height: 40px; width: auto; margin-bottom: 28px; }
        .ch-title {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 26px;
          font-weight: 600;
          letter-spacing: -0.01em;
          margin: 0;
        }
        .ch-subtitle {
          margin: 8px 0 28px;
          font-size: 14.5px;
          color: var(--muted);
          line-height: 1.5;
        }

        /* Alerts */
        .ch-alert {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 13.5px;
          padding: 11px 14px;
          border-radius: 10px;
          margin-bottom: 18px;
          box-sizing: border-box;
          animation: ch-fadeIn 0.3s ease;
        }
        .ch-alert-error {
          background: #fdf1f1;
          border: 1px solid #f3c9c9;
          color: var(--danger);
        }
        .ch-alert-success {
          background: var(--success-bg);
          border: 1px solid var(--success-border);
          color: var(--success-text);
        }

        @keyframes ch-fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .ch-field { margin-bottom: 24px; }
        .ch-label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 7px;
        }
        .ch-input-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }
        .ch-input-wrap .lead {
          position: absolute;
          left: 14px;
          color: var(--muted);
          display: flex;
          pointer-events: none;
        }
        .ch-input {
          width: 100%;
          height: 48px;
          padding: 0 16px 0 44px;
          font: inherit;
          font-size: 14.5px;
          color: var(--text);
          background: var(--card);
          border: 1.5px solid #dde2ea;
          border-radius: 11px;
          transition: border-color 0.15s, box-shadow 0.15s;
          box-sizing: border-box;
        }
        .ch-input::placeholder { color: #9aa4b4; }
        .ch-input:hover { border-color: #c3cbd8; }
        .ch-input:focus {
          outline: none;
          border-color: var(--accent);
          box-shadow: 0 0 0 4px var(--accent-soft);
        }

        .ch-submit {
          width: 100%;
          height: 50px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          font: inherit;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background: var(--ink);
          border: none;
          border-radius: 11px;
          cursor: pointer;
          transition: background 0.15s, transform 0.1s;
          box-sizing: border-box;
        }
        .ch-submit:hover:not(:disabled) { background: #1a2742; }
        .ch-submit:active:not(:disabled) { transform: translateY(1px); }
        .ch-submit:disabled { opacity: 0.75; cursor: default; }

        .ch-spinner {
          width: 18px; height: 18px;
          border-radius: 50%;
          border: 2.5px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          animation: ch-spin 0.7s linear infinite;
        }
        @keyframes ch-spin { to { transform: rotate(360deg); } }

        .ch-foot {
          margin-top: 26px;
          text-align: center;
        }
        .ch-back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 600;
          color: var(--muted);
          text-decoration: none;
          transition: color 0.2s ease;
        }
        .ch-back-link svg {
          transition: transform 0.2s ease;
        }
        .ch-back-link:hover {
          color: var(--text);
        }
        .ch-back-link:hover svg {
          transform: translateX(-4px);
        }

        :is(.ch-back-link, .ch-submit):focus-visible {
          outline: 2px solid var(--accent);
          outline-offset: 2px;
          border-radius: 8px;
        }

        /* ============ responsive & motion ============ */
        @media (max-width: 900px) {
          .ch-root { grid-template-columns: 1fr; }
          .ch-panel { display: none; }
          .ch-auth { position: static; height: auto; min-height: 100vh; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ch-card, .ch-meter i, .ch-alert { animation: none; }
          .ch-meter i { transform: scaleX(var(--fill, 1)); }
          .ch-spinner { animation-duration: 1.4s; }
        }
      `}</style>

      {/* ================= LEFT PANEL ================= */}
      <aside className="ch-panel" aria-hidden="true">
        <div className="ch-wordmark">
          COREHire<span className="dot">.AI</span>
        </div>

        <h1 className="ch-headline">
          Every resume read. Every candidate <em>ranked.</em>
        </h1>
        <p className="ch-sub">
          COREHire parses, scores, and ranks applicants the moment they apply —
          so your shortlist is ready before your first coffee.
        </p>

        <div className="ch-stack">
          {CANDIDATES.map((c) => (
            <div className="ch-card" key={c.initials}>
              <div className="ch-avatar">{c.initials}</div>
              <div>
                <div className="ch-card-name">{c.name}</div>
                <div className="ch-card-role">{c.role}</div>
                <div className="ch-tags">
                  {c.tags.map((t) => (
                    <span className="ch-tag" key={t}>{t}</span>
                  ))}
                </div>
              </div>
              <div className="ch-score">
                <div className="ch-score-num">{c.score}</div>
                <div className="ch-score-label">Match</div>
                <div className="ch-meter">
                  <i style={{ '--fill': c.score / 100 }} />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="ch-panel-foot">
          <div><strong>2× faster</strong>shortlisting</div>
          <div><strong>AI scoring</strong>on every resume</div>
          <div><strong>Analytics</strong>built in</div>
        </div>
      </aside>

      {/* ================= AUTH SIDE ================= */}
      <main className="ch-auth">
        <div className="ch-auth-card">
          <img src={logo} alt="COREHire" className="ch-logo" />
          <h2 className="ch-title">Forgot password?</h2>
          <p className="ch-subtitle">
            No worries. Enter your email address and we'll send you a link to reset your password.
          </p>

          {error && (
            <div className="ch-alert ch-alert-error" role="alert">
              {Icon.alert}
              <span>{error}</span>
            </div>
          )}

          {message && (
            <div className="ch-alert ch-alert-success" role="alert">
              {Icon.check}
              <span>{message}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate={false}>
            <div className="ch-field">
              <label className="ch-label" htmlFor="ch-email">Email Address</label>
              <div className="ch-input-wrap">
                <span className="lead">{Icon.mail}</span>
                <input
                  id="ch-email"
                  className="ch-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  autoComplete="email"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <button type="submit" className="ch-submit" disabled={loading}>
              {loading ? (
                <span className="ch-spinner" aria-label="Sending..." />
              ) : (
                "Send Reset Link"
              )}
            </button>
          </form>

          <div className="ch-foot">
            <Link to="/signin" className="ch-back-link">
              {Icon.arrowLeft} Back to sign in
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ForgotPassword;